var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "rgba(59,130,246,1)",
    width: "100%",
    height: "100%",
    viewBox: "-10.5 -9.45 21 18.9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-sm me-0 w-10 h-10 text-link dark:text-link-dark flex origin-center transition-all ease-in-out",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 10,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10,
    ry: 4.5,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10,
    ry: 4.5,
    transform: "rotate(120)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.e1daaf6a785c5937832b2a4bbf3bf05d.svg";
export { ForwardRef as ReactComponent };